module.exports = __webpack_public_path__ + "media/images/employer--8d8bb681648c80e5b5a02b50e1325c34.png";